module.exports = __webpack_public_path__ + "img/tractor-photo-01.19f62834.jpeg";